import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { ConfigService, fromMinutesToMilliseconds } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class GameConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientGaming>) {}

	getCacheMaxAgeForGetAll(): number {
		return fromMinutesToMilliseconds(this.configService.get((x) => x.gaming.game.cacheMaxAge!.getAll, 30));
	}

	getGameEndpoint(): string {
		return this.configService.get((x) => x.gaming.game.endpoints!.games, "v2/games");
	}

	getGameDetailEndpoint(): string {
		return this.configService.get((x) => x.gaming.game.endpoints!.game, "v1/games/:gameId/");
	}

	getGameByCollectionEndpoint(): string {
		return this.configService.get(
			(x) => x.gaming.game.endpoints!.gamesByCollection,
			"v1/gamesbycollection/:collectionId"
		);
	}

	getGamesByGameIdsEndpoint(): string {
		return this.configService.get((x) => x.gaming.game.endpoints?.gamesByGameIds, "v2/games/gameIds");
	}
}
